// frontend/src/services/api.ts
const API_URL = 'backend/api'; // Usamos rutas relativas

export const fetchCars = async (userId: number) => {
  const response = await fetch(`${API_URL}/cars.php?user_id=${userId}`);
  if (!response.ok) throw new Error('Error al obtener autos');
  return response.json();
};

export const fetchReminders = async (carId: number) => {
  const response = await fetch(`${API_URL}/reminders.php?car_id=${carId}`);
  if (!response.ok) throw new Error('Error al obtener recordatorios');
  return response.json();
};

export const fetchMaintenanceTypes = async () => {
  const response = await fetch(`${API_URL}/maintenance_types.php`);
  if (!response.ok) throw new Error('Error al obtener tipos de mantenimiento');
  return response.json();
};

export const addRecord = async (data: any) => {
  const response = await fetch(`${API_URL}/records.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al agregar registro');
  return response.json();
};

export const fetchMileageHistory = async (carId: number) => {
  const response = await fetch(`${API_URL}/mileage.php?car_id=${carId}`);
  if (!response.ok) throw new Error('Error al obtener historial de kilometraje');
  return response.json();
};

export const addMileageRecord = async (data: any) => {
  const response = await fetch(`${API_URL}/mileage.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al registrar kilometraje');
  return response.json();
};

export const fetchFuelRecords = async (carId: number) => {
  const response = await fetch(`${API_URL}/fuel.php?car_id=${carId}`);
  if (!response.ok) throw new Error('Error al obtener registros de combustible');
  return response.json();
};

export const addFuelRecord = async (data: any) => {
  const response = await fetch(`${API_URL}/fuel.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al registrar combustible');
  return response.json();
};
